import { toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["placeholder", "value"]
const _hoisted_11 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["placeholder", "value"]
const _hoisted_15 = { class: "form-group mb-2 col" }
const _hoisted_16 = { class: "col-auto p-0 text-end" }
const _hoisted_17 = { class: "row m-4 mb-0 mt-0 ms-3 me-3" }
const _hoisted_18 = { class: "col-xs-12 col-sm-6 col-lg-4 mb-1 ps-2 pe-2" }
const _hoisted_19 = { class: "card card-body mb-0" }
const _hoisted_20 = { class: "overflow-auto" }
const _hoisted_21 = { class: "text-center mb-1" }
const _hoisted_22 = { class: "d-block text-center text-capitalize-first" }
const _hoisted_23 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_24 = { class: "bg-light" }
const _hoisted_25 = { class: "text-capitalize" }
const _hoisted_26 = { class: "text-capitalize" }
const _hoisted_27 = { class: "text-capitalize" }
const _hoisted_28 = { class: "card card-body mb-0" }
const _hoisted_29 = { class: "overflow-auto" }
const _hoisted_30 = { class: "text-center mb-1" }
const _hoisted_31 = { class: "d-block text-center" }
const _hoisted_32 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_33 = { class: "bg-light" }
const _hoisted_34 = { class: "text-capitalize" }
const _hoisted_35 = { class: "text-capitalize" }
const _hoisted_36 = { class: "text-capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DatePicker, {
                    popover: {visibility: 'click'},
                    modelValue: _ctx.requestDTO.range,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.range) = $event)),
                    "model-modifiers": {string: true},
                    "is-range": "",
                    mode: "range",
                    masks: {input: 'YYYY-MM-DD', modelValue: 'YYYY-MM-DD'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("input", _mergeProps({
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue.start
                            }, _toHandlers(inputEvents.start, true)), null, 16, _hoisted_10)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("input", _mergeProps({
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue.end
                            }, _toHandlers(inputEvents.end, true)), null, 16, _hoisted_14)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.helper.trans('labels.total')), 1)
                ])
              ]),
              _createElementVNode("table", _hoisted_23, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_24, [
                    _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.operation')), 1),
                    _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                    _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.count')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items['total'], (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.operation
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`operation_type.${item.operation}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(item.totalSum, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.count, 0)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
          return (_openBlock(), _createElementBlock("div", {
            key: label.id,
            class: "col-xs-12 col-sm-6 col-lg-4 mb-1 ps-2 pe-2"
          }, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(label.label ?? label.id), 1)
                ]),
                _createElementVNode("table", _hoisted_32, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_33, [
                      _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.operation')), 1),
                      _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                      _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.count')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items[label.id], (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.operation
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`operation_type.${item.operation}`)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(item.totalSum, 2)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.count, 0)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}